import { defineStore } from 'pinia';
import Cookies from '@/assets/libraries/Cookies';

export const useAuthStore = defineStore({
	id: 'auth',

	state: () => ({
		access_token: Cookies.readCookie('token') ?? undefined,
		refresh_token: Cookies.readCookie('refresh_token') ?? undefined,
		user_info: undefined,
		subscriptions: null,
		subscriptions_last_received_at: undefined,
		active_products: [],
	}),

	actions: {
		setTokens({ access_token, refresh_token }) {
			this.access_token = access_token;
			this.refresh_token = refresh_token;

			Cookies.createCookie('token', access_token, 60, { cross_domain: true });
			Cookies.createCookie('refresh_token', refresh_token, 60, { cross_domain: true });
		},
		setUser(user_info) {
			this.user_info = user_info;
		},
		setSubscriptionDetails(subscriptions, subscriptions_last_received_at = undefined) {
			this.subscriptions = subscriptions;

			for (const subscription of subscriptions) {
				let product = subscription?.internal_product;
				if (product == 'CSC' && subscription?.price_id == 'price_LEGACY_CSC_LICENSE_KEY') {
					product = 'CSC_LEGACY';
				}

				if (this.active_products.includes(product) == true) {
					continue;
				}
				if (subscription.paid != true || subscription.canceled != false) {
					continue;
				}
				this.active_products.push(product);
			}

			this.subscriptions_last_received_at = subscriptions_last_received_at;
		},

		isUserLoggedIn() {
			return this.access_token != undefined && this.refresh_token != undefined && this.user_info != undefined;
		},

		logout() {
			this.access_token = undefined;
			this.refresh_token = undefined;
			this.user_info = undefined;
			Cookies.eraseCookie('token');
			Cookies.eraseCookie('refresh_token');

			this.$router.push({ path: `/` });
		},
	},
});
